import React, { Suspense } from 'react';
import * as Sentry from '@sentry/react';
// Importing the leaflet css at the root level for the maps to work
import 'leaflet/dist/leaflet.css';
import errorService from 'src/services/error-service';
import { SentryFallbackErrorScreen } from 'src/shared/components/error-screen/ErrorScreen';
import useRestoredReduxState from './useRestoredReduxState';
import App from '../app/App';
errorService.initializeReportingService();

export const Root = () => {
    // Restore preserved store data from local and session storage
    useRestoredReduxState();

    return (
        <div>
            <Sentry.ErrorBoundary fallback={SentryFallbackErrorScreen}>
                <Suspense>
                    <App />
                </Suspense>
            </Sentry.ErrorBoundary>
        </div>
    );
};

export default Root;
